export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["بعد إتمام الصفقة، سيتم إغلاقها. سيتم تحويل الأموال الداخلية إلى المستخدم."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["هل أنت متأكد أنك تريد إتمام الصفقة؟"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نعم، إتمام"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا، إبقاء نشطة"])}
}